// Source: app/scripts/controllers/subcategory-products.js
/**
 * Created by ristes on 20.4.15.
 */



Auction.controller('SubcategoryProductsController', [
  '$scope',
  '$translate',
  '$routeParams',
  'toaster',
  'crudService',
  function ($scope, $translate, $routeParams, toaster, crudService) {
    var service = crudService('products_view');
    $scope.pages = [];

    // obtaining current language
    $scope.lang = $translate.use() || $translate.proposedLanguage() || 'en';
    if ($scope.lang == 'gb') {
      $scope.lang = 'en';
    }
    if ($scope.lang) {
      $scope.lang = $scope.lang.toUpperCase();
    }

    var param = {
      'page': 1,
      'count': 3
    };

    $scope.clear = function () {
      if ($routeParams.id) {
        $scope.filter = {
          'subcategory.id': $routeParams.id
        };
      } else {
        $scope.filter = {};
      }
      param = {
        'page': 1,
        'count': 3
      };
      $scope.search();
    };


    //search function
    $scope.search = function (p) {
      if (p) {
        $scope.active = p;
      } else {
        $scope.active = 1;
      }
      param.page = $scope.active;
      var fiter = {};
      angular.forEach($scope.filter, function (v, k) {
        fiter['filter[' + k + ']'] = v;
      });
      param = angular.extend(param, fiter);

      service.paged(param, function (data) {
        $scope.entities = data.content;
        $scope.totalElements = data.totalElements;
        var pageNo = Math.ceil(data.totalElements / param.count);
        $scope.pages = [];
        for (var i = 1; i <= pageNo; i++) {
          $scope.pages.push(i);
        }
        $scope.total = pageNo;
        if ($scope.active > pageNo) {
          $scope.active = pageNo;
        }

      });
    };

    //paging
    $scope.total = 1;
    $scope.active = 1;
    $scope.previous = function () {
      if ($scope.active <= 1) return;
      $scope.search($scope.active - 1);
    };

    $scope.next = function () {
      if ($scope.active >= $scope.total) return;
      $scope.search($scope.active + 1);
    };

    $scope.activate = function (i) {
      if (i <= 0 && i > $scope.total) return;
      if (i == $scope.active) return;
      $scope.search(i);

    };


    // load the products
    $scope.clear();

  }
]);
